const RootLayout = () => {
  window.location = "/login";
}

export default RootLayout
